import { RefObject, useEffect } from "react";

/**
 * Dispara `handler` quando ocorre um `pointerdown` fora do elemento referenciado.
 * O listener só é registrado quando `enabled` é true (evita custo quando ocioso).
 */
export function useOnClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  handler: () => void,
  enabled = true,
): void {
  useEffect(() => {
    if (!enabled) return;

    const handlePointerDown = (event: PointerEvent) => {
      if (!ref.current?.contains(event.target as Node)) {
        handler();
      }
    };

    document.addEventListener("pointerdown", handlePointerDown);
    return () => document.removeEventListener("pointerdown", handlePointerDown);
  }, [ref, handler, enabled]);
}
